import { render, staticRenderFns } from "./ProductDetailAlertSetting.vue?vue&type=template&id=a9509fe2&scoped=true&"
import script from "./ProductDetailAlertSetting.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailAlertSetting.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailAlertSetting.vue?vue&type=style&index=0&id=a9509fe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9509fe2",
  null
  
)

export default component.exports